export class ResolvedRepositorySource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "type",
            "baseName": "type",
            "type": "string",
            "format": ""
        },
        {
            "name": "repositoryId",
            "baseName": "repositoryId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "commitSha",
            "baseName": "commitSha",
            "type": "string",
            "format": ""
        },
        {
            "name": "rootPath",
            "baseName": "rootPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "entryPointPath",
            "baseName": "entryPointPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "artifactUri",
            "baseName": "artifactUri",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ResolvedRepositorySource.attributeTypeMap;
    }
    constructor() {
    }
}
